import { FUNDING_REQUIREMENTS_FIXTURE } from '../components/RequirementsList/fundingRequirements.fixture';
import {
    TRequirement,
    TRequirementsSummary
} from '../components/RequirementsList/fundingRequirements.types';

export function useGetFundingRequirements(): {
    requirements: TRequirement[];
    summary: TRequirementsSummary;
} {
    return FUNDING_REQUIREMENTS_FIXTURE.data;
}
